import React, { useState, useEffect } from "react";
import { CheckIcon, ChevronsUpDownIcon, XIcon } from "lucide-react";

import industryColorMap from "./IndustryMapping";
import IndexTable from "./IndexData";

const getUniqueStocks = (strategy) => {
  console.log("Strategy dat ais i sthis", strategy);
  const stockSet = new Set();
  Object.values(strategy).forEach((stocks) => {
    stocks?.forEach((stockData) => {
      stockSet.add(stockData.symbol);
    });
  });

  console.log("Stock set is", stockSet);
  return Array.from(stockSet);
};

const getStockDetails = (strategy) => {
  const stockDetails = {};
  Object.values(strategy).forEach((stocks) => {
    stocks?.forEach((stockData) => {
      if (!stockDetails[stockData.symbol]) {
        stockDetails[stockData.symbol] = {
          stock: stockData.symbol,
          p4: stockData.p4 || "-",
          sector: stockData.sector || "-",
        };
      }
    });
  });
  return Object.values(stockDetails);
};

const ComparisonTable = ({
  strategyName,
  strategyData,
  indexColorCodeData,
  loading,
  error,
  indexData
}) => {
  const stocksList = getUniqueStocks(strategyData);
  const stockDetails = getStockDetails(strategyData);
  const [sortConfig, setSortConfig] = useState({});



  const handleSort = (version, key) => {
    setSortConfig((prev) => {
      const isAsc = prev.version === version && prev.key === key && !prev.isAsc;
      return { version, key, isAsc };
    });
  };

  const sortedStocks = [...stocksList].sort((a, b) => {
    if (!sortConfig.version || !sortConfig.key) return 0;

    const stockA = strategyData[sortConfig.version].find((s) => s.symbol === a);
    const stockB = strategyData[sortConfig.version].find((s) => s.symbol === b);

    let valueA = stockA ? stockA[sortConfig.key] : null;
    let valueB = stockB ? stockB[sortConfig.key] : null;

    // Special logic for "in" key with tag priority
    if (sortConfig.key === "in") {
      const isAHighPriority = valueA === 1 && stockA?.tag !== "sell";
      const isBHighPriority = valueB === 1 && stockB?.tag !== "sell";

      if (isAHighPriority && !isBHighPriority) return -1;
      if (!isAHighPriority && isBHighPriority) return 1;
      // If both are high or both are not, continue to compare values normally
    }

    // Convert rsr and id to numbers
    if (sortConfig.key === "rsr" || sortConfig.key === "id") {
      valueA = valueA !== null ? Number(valueA) : null;
      valueB = valueB !== null ? Number(valueB) : null;
    }

    if (valueA === null) return 1;
    if (valueB === null) return -1;

    if (sortConfig.isAsc) {
      return valueA > valueB ? 1 : -1;
    } else {
      return valueA < valueB ? 1 : -1;
    }
  });

  const getBackgroundColor = (strategyName, version) => {
    console.log("Strategy name", strategyName);
    const filteredData = indexColorCodeData.filter(
      (item) => item.index === strategyName
    );

    console.log("Filtered data", filteredData);
    console.log("Version", version);

    if (filteredData.length > 0) {
      const matchingStrategies = filteredData.filter(
        (item) => item.strategy === version
      );

      if (matchingStrategies.length > 0) {
        return matchingStrategies[0]?.color_code
      }
    }

    return "";
  };

    // Create sorted strategy versions once and use everywhere
  const sortedStrategyVersions = Object.keys(strategyData).sort((a, b) => {
    const colorA = getBackgroundColor(strategyName, a);
    const colorB = getBackgroundColor(strategyName, b);
    
    // Items with custom background color come first
    const hasColorA = colorA && colorA !== '#1f2937';
    const hasColorB = colorB && colorB !== '#1f2937';
    
    if (hasColorA && !hasColorB) return -1;
    if (!hasColorA && hasColorB) return 1;
    return 0;
  });

  return (
    <div className={`flex p-0 text-white w-full min-h-[calc(100vh-80px)] `}>
      <div className="relative">
        <table className={`text-[12px] w-full h-full`} style={{borderSpacing: 0, borderCollapse: 'separate'}}>
          <thead className="sticky top-0 z-20">
            <tr>
              <th className="border-2 border-white px-4 py-[1px] sticky left-0 z-30" 
                  style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}} rowSpan={2}>
                Stocks
              </th>

              {sortedStrategyVersions.map((version, i) => {
               
               const backgroundColor = getBackgroundColor(strategyName, version);
               console.log("Background color", backgroundColor);

               return (
                <th
                    key={version}
                    colSpan={4}
                    style={{backgroundColor: backgroundColor || '#1f2937', borderColor: '#d1d5db'}}
                    className={`border-2 border-white px-4 py-[1px] text-center`}
                  >
                    {version}
                  </th>
               )
              })}

              <th
                className="min-w-[100px] border-2 border-white px-4 py-[1px]"
                style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
                rowSpan={2}
              >
                P4
              </th>
              <th
                className="min-w-[220px] border-2 border-white px-4 py-[1px]"
                style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
                rowSpan={2}
              >
                Sector
              </th>
              <th
                className="min-w-[180px] border-2 border-white px-4 py-[1px]"
                style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
                rowSpan={2}
              >
                Industry
              </th>
            </tr>
            <tr>

              {sortedStrategyVersions.map((version) => (
                <>
                  <th
                    key={version}
                    className="border-2 border-white px-2 py-[1px] cursor-pointer"
                    style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
                  >
                    <div className="flex flex-col items-center">
                      <span>S</span>
                    </div>
                  </th>
                  <th
                    key={version}
                    className="border-2 border-white px-2 py-[1px] cursor-pointer"
                    style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
                    onClick={() => handleSort(version, "in")}
                  >
                    <div className="flex flex-col items-center">
                      <span>In</span>
                      <ChevronsUpDownIcon className="h-3 w-3 inline" />
                    </div>
                  </th>
                  <th
                    className="border-2 border-white px-2 py-[1px] cursor-pointer"
                    style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
                    onClick={() => handleSort(version, "rsr")}
                  >
                    <div className="flex flex-col items-center">
                      <span>Rsr</span>
                      <ChevronsUpDownIcon className="h-3 w-3 inline" />
                    </div>
                  </th>
                  <th
                    className="border-2 border-white px-2 py-[1px] cursor-pointer"
                    style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
                    onClick={() => handleSort(version, "id")}
                  >
                    <div className="flex flex-col items-center">
                      <span>Id</span>
                      <ChevronsUpDownIcon className="h-3 w-3 inline" />
                    </div>
                  </th>
                </>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedStocks.map((stock, index) => {
              return (
                <tr key={`${stock}_${index}`}>
                  <td className="border border-gray-300 px-2 py-[1px] min-w-[100px] sticky left-0 z-10 shadow-[2px_0_5px_rgba(0,0,0,0.1)]" 
                      style={{backgroundColor: '#1f2937'}}>
                    <div className="flex text-[11px] items-start gap-2">
                      <span>{index + 1}.</span>
                      <span className="ml-[3px]">{stock}</span>
                    </div>
                  </td>
                  {sortedStrategyVersions.map((version) => {
                    const stockData = strategyData[version].find(
                      (s) => s.symbol === stock
                    );
                    return (
                      <>
                        <td className="border  border-gray-300 px-2 py-[1px] text-center">
                          <div className="flex items-center justify-center">
                            {stockData?.tag === "buy" ? (
                              <div className="h-2 w-2 rounded-full bg-green-500" />
                            ) : stockData?.tag === "sell" ? (
                              <div className="h-2 w-2 rounded-full bg-rose-500" />
                            ) : stockData?.tag === "hold" ? (
                              <div className="h-2 w-2 rounded-full bg-amber-500" />
                            ) : (
                              "-"
                            )}
                          </div>
                        </td>
                        <td className="border border-gray-300 px-2 py-[1px] text-center">
                          {stockData?.in === 1 && stockData?.tag !== "sell" ? (
                            <CheckIcon className="h-4 w-4 text-emerald-500" />
                          ) : stockData?.in === 1 && stockData?.tag === "sell" ? (
                            <XIcon className="h-4 w-4 text-rose-500" />
                          ) : (
                            "-"
                          )}
                        </td>
                        <td className="border border-gray-300 px-2 py-[1px] text-center">
                          {stockData?.rsr !== null && !isNaN(stockData?.rsr)
                            ? parseFloat(stockData?.rsr)?.toFixed(2)
                            : "-"}
                        </td>
                        <td className="border border-gray-300 px-2 py-[1px] text-center">
                          {(stockData?.id !== null) & !isNaN(stockData?.rsr)
                            ? parseFloat(stockData?.id)?.toFixed(2)
                            : "-"}
                        </td>
                      </>
                    );
                  })}

                  {stockDetails.map((stockData) => {
                    return stockData.stock === stock ? (
                      <>
                        <td className="border border-gray-300 px-2 py-[1px] text-center">
                          {stockData?.p4}
                        </td>
                        <td className="py-[4px] border border-gray-300 px-2 text-center">
                          <div
                            className={` ${
                              industryColorMap[`${stockData?.sector}`]
                            } text-white font-medium text-[12px] py-[2px] rounded-[4px]`}
                          >
                            {stockData?.sector}
                          </div>
                        </td>
                        <td className="border border-gray-300 px-2 py-[1px] text-center">
                          -
                        </td>
                      </>
                    ) : null;
                  })}
                </tr>
              );
            })}

            <tr className="font-semibold">
              <td className="border border-gray-300 px-2 py-[1px] text-right sticky left-0 z-10 shadow-[2px_0_5px_rgba(0,0,0,0.1)]" 
                  style={{backgroundColor: '#1f2937'}}></td>


              {sortedStrategyVersions.map((version) => {
                const totalYellowAndRed = strategyData[version].reduce(
                  (sum, item) =>
                    (item.tag === "hold" || item.tag === "sell") && item.rsr
                      ? sum + Number(item.rsr)
                      : sum,
                  0
                );

                const totalYellowAndGreen = strategyData[version].reduce(
                  (sum, item) =>
                    (item.tag === "hold" || item.tag === "buy") && item.rsr
                      ? sum + Number(item.rsr)
                      : sum,
                  0
                );
                return (
                  <React.Fragment key={`totalrsr_${version}`}>
                    <td
                      colSpan={4}
                      className="border border-gray-300 px-2 py-[1px] text-center"
                    >
                      <div className="flex items-center justify-between px-[10px]">
                        <div className="flex flex-col">
                          <div className="flex space-x-2">
                            <span className="text-amber-500">Y</span>
                            <span className="text-white">+</span>
                            <span className="text-rose-500">R</span>
                          </div>

                          <span className="text-white">
                            {totalYellowAndRed.toFixed(2)}
                          </span>
                        </div>
                        <div>|</div>
                        <div className="flex flex-col">
                          <div className="flex space-x-2">
                            <span className="text-amber-500">Y</span>
                            <span className="text-white">+</span>
                            <span className="text-emerald-500">G</span>
                          </div>

                          <span className="text-white">
                            {totalYellowAndGreen.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </td>
                  </React.Fragment>
                );
              })}
              <td className="border border-gray-300 px-2 py-[1px] text-center">
                -
              </td>
              <td className="border border-gray-300 px-2 py-[1px] text-center">
                -
              </td>
              <td className="border border-gray-300 px-2 py-[1px] text-center">
                -
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className=" border-[1px] text-white border-white min-h-[calc(100vh-80px)]">
        <IndexTable loading={loading} error={error} indexData={indexData} />
      </div>
    </div>
  );
};


const AlphaIndiaTables = ({ data , loading,error,indexData,indexColorCodeData }) => {
  

  return (
    <div className="flex w-full h-full">
      {Object.entries(data).map(([strategyName, strategyData], idx) => (
        <ComparisonTable
          key={`${strategyName}_${idx}`}
          strategyName={strategyName}
          strategyData={strategyData}
          indexColorCodeData={indexColorCodeData}
          loading={loading}
          error={error}
          indexData={indexData}
        />
      ))}
      
    </div>
  );
};

export default AlphaIndiaTables;

















































































// import React, { useState, useEffect } from "react";
// import { CheckIcon, ChevronsUpDownIcon, XIcon } from "lucide-react";

// import industryColorMap from "./IndustryMapping";
// import IndexTable from "./IndexData";

// const getUniqueStocks = (strategy) => {
//   console.log("Strategy dat ais i sthis", strategy);
//   const stockSet = new Set();
//   Object.values(strategy).forEach((stocks) => {
//     stocks?.forEach((stockData) => {
//       stockSet.add(stockData.symbol);
//     });
//   });

//   console.log("Stock set is", stockSet);
//   return Array.from(stockSet);
// };

// const getStockDetails = (strategy) => {
//   const stockDetails = {};
//   Object.values(strategy).forEach((stocks) => {
//     stocks?.forEach((stockData) => {
//       if (!stockDetails[stockData.symbol]) {
//         stockDetails[stockData.symbol] = {
//           stock: stockData.symbol,
//           p4: stockData.p4 || "-",
//           sector: stockData.sector || "-",
//         };
//       }
//     });
//   });
//   return Object.values(stockDetails);
// };

// const ComparisonTable = ({
//   strategyName,
//   strategyData,
//   indexColorCodeData,
//   loading,
//   error,
//   indexData
// }) => {
//   const stocksList = getUniqueStocks(strategyData);
//   const stockDetails = getStockDetails(strategyData);
//   const [sortConfig, setSortConfig] = useState({});

//   const handleSort = (version, key) => {
//     setSortConfig((prev) => {
//       const isAsc = prev.version === version && prev.key === key && !prev.isAsc;
//       return { version, key, isAsc };
//     });
//   };

//   const sortedStocks = [...stocksList].sort((a, b) => {
//     if (!sortConfig.version || !sortConfig.key) return 0;

//     const stockA = strategyData[sortConfig.version].find((s) => s.symbol === a);
//     const stockB = strategyData[sortConfig.version].find((s) => s.symbol === b);

//     let valueA = stockA ? stockA[sortConfig.key] : null;
//     let valueB = stockB ? stockB[sortConfig.key] : null;

//     // Special logic for "in" key with tag priority
//     if (sortConfig.key === "in") {
//       const isAHighPriority = valueA === 1 && stockA?.tag !== "sell";
//       const isBHighPriority = valueB === 1 && stockB?.tag !== "sell";

//       if (isAHighPriority && !isBHighPriority) return -1;
//       if (!isAHighPriority && isBHighPriority) return 1;
//       // If both are high or both are not, continue to compare values normally
//     }

//     // Convert rsr and id to numbers
//     if (sortConfig.key === "rsr" || sortConfig.key === "id") {
//       valueA = valueA !== null ? Number(valueA) : null;
//       valueB = valueB !== null ? Number(valueB) : null;
//     }

//     if (valueA === null) return 1;
//     if (valueB === null) return -1;

//     if (sortConfig.isAsc) {
//       return valueA > valueB ? 1 : -1;
//     } else {
//       return valueA < valueB ? 1 : -1;
//     }
//   });

//   const getBackgroundColor = (strategyName, version) => {
//     console.log("Strategy name", strategyName);
//     const filteredData = indexColorCodeData.filter(
//       (item) => item.index === strategyName
//     );

//     console.log("Filtered data", filteredData);
//     console.log("Version", version);

//     if (filteredData.length > 0) {
//       const matchingStrategies = filteredData.filter(
//         (item) => item.strategy === version
//       );

//       if (matchingStrategies.length > 0) {
//         return matchingStrategies[0]?.color_code
//       }
//     }

//     return "";
//   };

//   return (
//     <div className={`flex p-0 text-white w-full min-h-[calc(100vh-80px)] `}>
//       <div className="relative">
//         <table className={`text-[12px] w-full h-full`} style={{borderSpacing: 0, borderCollapse: 'separate'}}>
//           <thead className="sticky top-0 z-20">
//             <tr>
//               <th className="border-2 border-white px-4 py-[1px] sticky left-0 z-30" 
//                   style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}} rowSpan={2}>
//                 Stocks
//               </th>

//               {Object.keys(strategyData).map((version, i) => {
               
//                const backgroundColor = getBackgroundColor(strategyName, version);
//                console.log("Background color", backgroundColor);

//                return (
//                 <th
//                     key={version}
//                     colSpan={4}
//                     style={{backgroundColor: backgroundColor || '#1f2937', borderColor: '#d1d5db'}}
//                     className={`border-2 border-white px-4 py-[1px] text-center`}
//                   >
//                     {version}
//                   </th>
//                )
//               })}

//               <th
//                 className="min-w-[100px] border-2 border-white px-4 py-[1px]"
//                 style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
//                 rowSpan={2}
//               >
//                 P4
//               </th>
//               <th
//                 className="min-w-[220px] border-2 border-white px-4 py-[1px]"
//                 style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
//                 rowSpan={2}
//               >
//                 Sector
//               </th>
//               <th
//                 className="min-w-[180px] border-2 border-white px-4 py-[1px]"
//                 style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
//                 rowSpan={2}
//               >
//                 Industry
//               </th>
//             </tr>
//             <tr>
//               {Object.keys(strategyData).map((version) => (
//                 <>
//                   <th
//                     key={version}
//                     className="border-2 border-white px-2 py-[1px] cursor-pointer"
//                     style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
//                   >
//                     <div className="flex flex-col items-center">
//                       <span>S</span>
//                     </div>
//                   </th>
//                   <th
//                     key={version}
//                     className="border-2 border-white px-2 py-[1px] cursor-pointer"
//                     style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
//                     onClick={() => handleSort(version, "in")}
//                   >
//                     <div className="flex flex-col items-center">
//                       <span>In</span>
//                       <ChevronsUpDownIcon className="h-3 w-3 inline" />
//                     </div>
//                   </th>
//                   <th
//                     className="border-2 border-white px-2 py-[1px] cursor-pointer"
//                     style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
//                     onClick={() => handleSort(version, "rsr")}
//                   >
//                     <div className="flex flex-col items-center">
//                       <span>Rsr</span>
//                       <ChevronsUpDownIcon className="h-3 w-3 inline" />
//                     </div>
//                   </th>
//                   <th
//                     className="border-2 border-white px-2 py-[1px] cursor-pointer"
//                     style={{backgroundColor: '#1f2937', borderColor: '#d1d5db'}}
//                     onClick={() => handleSort(version, "id")}
//                   >
//                     <div className="flex flex-col items-center">
//                       <span>Id</span>
//                       <ChevronsUpDownIcon className="h-3 w-3 inline" />
//                     </div>
//                   </th>
//                 </>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {sortedStocks.map((stock, index) => {
//               return (
//                 <tr key={`${stock}_${index}`}>
//                   <td className="border border-gray-300 px-2 py-[1px] min-w-[100px] sticky left-0 z-10 shadow-[2px_0_5px_rgba(0,0,0,0.1)]" 
//                       style={{backgroundColor: '#1f2937'}}>
//                     <div className="flex text-[11px] items-start gap-2">
//                       <span>{index + 1}.</span>
//                       <span className="ml-[3px]">{stock}</span>
//                     </div>
//                   </td>
//                   {Object.keys(strategyData).map((version) => {
//                     const stockData = strategyData[version].find(
//                       (s) => s.symbol === stock
//                     );
//                     return (
//                       <>
//                         <td className="border  border-gray-300 px-2 py-[1px] text-center">
//                           <div className="flex items-center justify-center">
//                             {stockData?.tag === "buy" ? (
//                               <div className="h-2 w-2 rounded-full bg-green-500" />
//                             ) : stockData?.tag === "sell" ? (
//                               <div className="h-2 w-2 rounded-full bg-rose-500" />
//                             ) : stockData?.tag === "hold" ? (
//                               <div className="h-2 w-2 rounded-full bg-amber-500" />
//                             ) : (
//                               "-"
//                             )}
//                           </div>
//                         </td>
//                         <td className="border border-gray-300 px-2 py-[1px] text-center">
//                           {stockData?.in === 1 && stockData?.tag !== "sell" ? (
//                             <CheckIcon className="h-4 w-4 text-emerald-500" />
//                           ) : stockData?.in === 1 && stockData?.tag === "sell" ? (
//                             <XIcon className="h-4 w-4 text-rose-500" />
//                           ) : (
//                             "-"
//                           )}
//                         </td>
//                         <td className="border border-gray-300 px-2 py-[1px] text-center">
//                           {stockData?.rsr !== null && !isNaN(stockData?.rsr)
//                             ? parseFloat(stockData?.rsr)?.toFixed(2)
//                             : "-"}
//                         </td>
//                         <td className="border border-gray-300 px-2 py-[1px] text-center">
//                           {(stockData?.id !== null) & !isNaN(stockData?.rsr)
//                             ? parseFloat(stockData?.id)?.toFixed(2)
//                             : "-"}
//                         </td>
//                       </>
//                     );
//                   })}

//                   {stockDetails.map((stockData) => {
//                     return stockData.stock === stock ? (
//                       <>
//                         <td className="border border-gray-300 px-2 py-[1px] text-center">
//                           {stockData?.p4}
//                         </td>
//                         <td className="py-[4px] border border-gray-300 px-2 text-center">
//                           <div
//                             className={` ${
//                               industryColorMap[`${stockData?.sector}`]
//                             } text-white font-medium text-[12px] py-[2px] rounded-[4px]`}
//                           >
//                             {stockData?.sector}
//                           </div>
//                         </td>
//                         <td className="border border-gray-300 px-2 py-[1px] text-center">
//                           -
//                         </td>
//                       </>
//                     ) : null;
//                   })}
//                 </tr>
//               );
//             })}

//             <tr className="font-semibold">
//               <td className="border border-gray-300 px-2 py-[1px] text-right sticky left-0 z-10 shadow-[2px_0_5px_rgba(0,0,0,0.1)]" 
//                   style={{backgroundColor: '#1f2937'}}></td>

//               {Object.keys(strategyData).map((version) => {
//                 const totalYellowAndRed = strategyData[version].reduce(
//                   (sum, item) =>
//                     (item.tag === "hold" || item.tag === "sell") && item.rsr
//                       ? sum + Number(item.rsr)
//                       : sum,
//                   0
//                 );

//                 const totalYellowAndGreen = strategyData[version].reduce(
//                   (sum, item) =>
//                     (item.tag === "hold" || item.tag === "buy") && item.rsr
//                       ? sum + Number(item.rsr)
//                       : sum,
//                   0
//                 );
//                 return (
//                   <React.Fragment key={`totalrsr_${version}`}>
//                     <td
//                       colSpan={4}
//                       className="border border-gray-300 px-2 py-[1px] text-center"
//                     >
//                       <div className="flex items-center justify-between px-[10px]">
//                         <div className="flex flex-col">
//                           <div className="flex space-x-2">
//                             <span className="text-amber-500">Y</span>
//                             <span className="text-white">+</span>
//                             <span className="text-rose-500">R</span>
//                           </div>

//                           <span className="text-white">
//                             {totalYellowAndRed.toFixed(2)}
//                           </span>
//                         </div>
//                         <div>|</div>
//                         <div className="flex flex-col">
//                           <div className="flex space-x-2">
//                             <span className="text-amber-500">Y</span>
//                             <span className="text-white">+</span>
//                             <span className="text-emerald-500">G</span>
//                           </div>

//                           <span className="text-white">
//                             {totalYellowAndGreen.toFixed(2)}
//                           </span>
//                         </div>
//                       </div>
//                     </td>
//                   </React.Fragment>
//                 );
//               })}
//               <td className="border border-gray-300 px-2 py-[1px] text-center">
//                 -
//               </td>
//               <td className="border border-gray-300 px-2 py-[1px] text-center">
//                 -
//               </td>
//               <td className="border border-gray-300 px-2 py-[1px] text-center">
//                 -
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//       <div className=" border-[1px] text-white border-white min-h-[calc(100vh-80px)]">
//         <IndexTable loading={loading} error={error} indexData={indexData} />
//       </div>
//     </div>
//   );
// };

// const AlphaIndiaTables = ({ data , loading,error,indexData,indexColorCodeData }) => {
  

//   return (
//     <div className="flex w-full h-full">
//       {Object.entries(data).map(([strategyName, strategyData], idx) => (
//         <ComparisonTable
//           key={`${strategyName}_${idx}`}
//           strategyName={strategyName}
//           strategyData={strategyData}
//           indexColorCodeData={indexColorCodeData}
//           loading={loading}
//           error={error}
//           indexData={indexData}
//         />
//       ))}
      
//     </div>
//   );
// };

// export default AlphaIndiaTables;
